import { create } from 'zustand';
import { combine } from 'zustand/middleware';
import { IFormInitialState } from '~/components/billing-address/errorLogic';
import { INPUT_ID_OUTSTANDING_AMOUNT } from '~/constant/constants';
import { ISyfDetails } from '~/interfaces/payment';
import { IGetPricing } from '~/interfaces/commerce-types';

export const wmapStore = create(
  combine(
    {
      errorMessage: '',
      isCreditCardValid: false,
      submitPaymentClicked: false,
      userSelectedAmount: 0,
      billingAddressState: {} as IFormInitialState,
      isLoading: true,
      syfDetails: {} as ISyfDetails,
      selectedAmountOption: INPUT_ID_OUTSTANDING_AMOUNT,
      selectedPaymentOption: '',
      progressiveDetails: {} as IGetPricing,
      paymentReview: {
        review: false,
      },
      orderInProgress: false,
      paymentConnectorId: '' as string,
      cartId: '' as string | null,
      syfOverlay: false,
    },
    (set) => ({
      setErrorMessage: (message: string) => set({ errorMessage: message }),
      clearErrorMessage: () => set({ errorMessage: '' }),
      setCreditCardValid: (isValid: boolean) =>
        set({ isCreditCardValid: isValid }),
      handleSubmitPayment: () => set({ submitPaymentClicked: true }),
      resetSubmitPaymentClicked: () => set({ submitPaymentClicked: false }),
      setUserSelectedAmount: (amount: number) =>
        set({ userSelectedAmount: amount }),
      setBillingAddress: (address: IFormInitialState) =>
        set({ billingAddressState: address }),
      setIsLoading: (loading: boolean) => set({ isLoading: loading }),
      setSyfDetails: (details: ISyfDetails) => set({ syfDetails: details }),
      setSelectedAmountOption: (option: string) =>
        set({ selectedAmountOption: option }),
      setSelectedPaymentOption: (option: string) =>
        set({ selectedPaymentOption: option }),
      setProgressiveDetails: (details: IGetPricing) =>
        set({ progressiveDetails: details }),
      setPaymentReview: (review: { review: boolean }) =>
        set({ paymentReview: review }),
      setOrderInProgress: (inProgress: boolean) =>
        set({ orderInProgress: inProgress }),
      setPaymentConnectorId: (id: string) => set({ paymentConnectorId: id }),
      setCartId: (id: string | null) => set({ cartId: id }),
      setSyfOverlay: (value: boolean) => set({ syfOverlay: value }),
    }),
  ),
);

export const useErrorMessage = () => wmapStore((state) => state.errorMessage);
export const useClearErrorMessage = () =>
  wmapStore((state) => state.clearErrorMessage);
export const useSetErrorMessage = () =>
  wmapStore((state) => state.setErrorMessage);

export const useIsCreditCardValid = () =>
  wmapStore((state) => state.isCreditCardValid);
export const useSetCreditCardValid = () =>
  wmapStore((state) => state.setCreditCardValid);
export const useSubmitPaymentClicked = () =>
  wmapStore((state) => state.submitPaymentClicked);
export const useHandlePaymentClicked = () =>
  wmapStore((state) => state.handleSubmitPayment);
export const useResetSubmitPaymentClicked = () =>
  wmapStore((state) => state.resetSubmitPaymentClicked);

export const useUserSelectedAmount = () =>
  wmapStore((state) => state.userSelectedAmount);
export const useSetUserSelectedAmount = () =>
  wmapStore((state) => state.setUserSelectedAmount);

export const useBillingAddressState = () =>
  wmapStore((state) => state.billingAddressState);
export const useSetBillingAddress = () =>
  wmapStore((state) => state.setBillingAddress);

export const useIsLoading = () => wmapStore((state) => state.isLoading);
export const useSetIsLoading = () => wmapStore((state) => state.setIsLoading);

export const useSyfDetails = () => wmapStore((state) => state.syfDetails);
export const useSetSyfDetails = () => wmapStore((state) => state.setSyfDetails);
export const useSelectedAmountOption = () =>
  wmapStore((state) => state.selectedAmountOption);
export const useSetSelectedAmountOption = () =>
  wmapStore((state) => state.setSelectedAmountOption);
export const useSelectedPaymentOption = () =>
  wmapStore((state) => state.selectedPaymentOption);
export const useSetSelectedPaymentOption = () =>
  wmapStore((state) => state.setSelectedPaymentOption);
export const useProgressiveDetails = () =>
  wmapStore((state) => state.progressiveDetails);
export const useSetProgressiveDetails = () =>
  wmapStore((state) => state.setProgressiveDetails);
export const usePaymentReview = () => wmapStore((state) => state.paymentReview);
export const useSetPaymentReview = () =>
  wmapStore((state) => state.setPaymentReview);
export const useOrderInProgress = () =>
  wmapStore((state) => state.orderInProgress);
export const useSetOrderInProgress = () =>
  wmapStore((state) => state.setOrderInProgress);
export const usePaymentConnectorId = () =>
  wmapStore((state) => state.paymentConnectorId);
export const useSetPaymentConnectorId = () =>
  wmapStore((state) => state.setPaymentConnectorId);
export const useCartId = () => wmapStore((state) => state.cartId);
export const useSetCartId = () => wmapStore((state) => state.setCartId);
export const useSyfOverlay = () => wmapStore((state) => state.syfOverlay);
export const useSetSyfOverlay = () => wmapStore((state) => state.setSyfOverlay);
